import React from "react";
import { Row, Col, Container } from 'react-bootstrap';
import NavBar from "../../marginals/navBar";
import ClaimMain from "../claimForms/main";
import { getMbServerToken } from "../../../utils/cookieUtils";

export default function ClaimLanding(props) {
    const page = "Create Claim";
    let access_token = getMbServerToken()?.trim() || false;
    let eligibleColumns = localStorage.getItem('eligibleColumns')
    const entityidCheck =
      JSON.parse(localStorage.getItem("eligibleColumns"))?.[0]?.pmentityid ===
      11185545
        ? true
        : false;
    // const entityidCheck = false;
    return (
        <main>
            <NavBar page={ page } redirect={ 0 } userName={ props.userName } />
            {
                entityidCheck ? 
                <Container>
                    <div>Reimbursements are temporarily disabled for Wells Fargo, No worries, you can still meet your health care needs(consults, labs ,medicines,etc)
                        by placing cashless orders on Medibuddy via your OPD wallet
                    </div>
                </Container> : 
                <Container>
                    <div style={ { overflow: "visible" } }>
                        <Container>
                            <Row style={ { alignItems: "baseline" } }>
                                <Col sm={ 12 } xs={ 12 }><ClaimMain eligibleColumns={ eligibleColumns } accessToken={ access_token } /></Col>
                            </Row>
                        </Container>
                    </div>
                </Container> 
            }
        </main>
    )
}
